<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import CheckBox from '@/Components/CheckBox.svelte';
	// Services
	import { notify } from '@/Services/Notify';

	export let marketType;
	export let open;

	const dispatch = createEventDispatcher();

	let sending = false;
	let errors;

	let marketTypeForm = {
		name: marketType.name,
		label: marketType.label,
		price_order: marketType.price_order,
		rule: marketType.rule,
		selection_win_limit_factor: marketType.selection_win_limit_factor,
		cashout_enabled: marketType.cashout_enabled,
		traded_pre_match: marketType.traded_pre_match,
		traded_in_play: marketType.traded_in_play
	};

	function updateMarketType() {
		sending = true;
		if (marketTypeForm.name === marketType.name || !marketType.is_manual) {
			delete marketTypeForm.name;
		}
		if (marketTypeForm.label === marketType.label) {
			delete marketTypeForm.label;
		}
		if (marketTypeForm.price_order === marketType.price_order) {
			delete marketTypeForm.price_order;
		}
		if (marketTypeForm.selection_win_limit_factor === marketType.selection_win_limit_factor) {
			delete marketTypeForm.selection_win_limit_factor;
		}
		if (marketTypeForm.cashout_enabled === marketType.cashout_enabled) {
			delete marketTypeForm.cashout_enabled;
		}
		if (marketTypeForm.traded_pre_match === marketType.traded_pre_match) {
			delete marketTypeForm.traded_pre_match;
		}
		if (marketTypeForm.traded_in_play === marketType.traded_in_play) {
			delete marketTypeForm.traded_in_play;
		}
		marketType
			.patch(marketTypeForm)
			.then(() => {
				notify({
					type: 'success',
					title: 'Market type successfully updated',
					message: `${marketType.name} successfully updated!`,
					timeout: 3
				});
				dispatch('updated');
				open = false;
				marketTypeForm = {
					name: marketType.name,
					rule: marketType.rule,
					price_order: marketType.price_order
				};
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Error!',
					message: 'Problem updating market type',
					timeout: 3
				});
				marketTypeForm.name = marketType.name;
			})
			.finally(() => (sending = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">
			Update market type - {marketType.name}
		</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<TextInput
				label="Name"
				name="marketTypeName"
				className="py-4 w-full text-left"
				required={true}
				errors={errors && errors.name}
				disabled={!marketType.is_manual}
				placeholder="Enter market type name"
				bind:value={marketTypeForm.name}
			/>
			<TextInput
				label="Rule"
				name="marketTypeRule"
				className="py-4 w-full text-left"
				errors={errors && errors.rule}
				placeholder="Enter market type rule"
				bind:value={marketTypeForm.rule}
			/>
			<TextInput
				label="Limit factor"
				type="number"
				min="0.1"
				name="selection_win_limit_factor"
				className="py-4 w-full text-left"
				errors={errors && errors.selection_win_limit_factor}
				placeholder="Enter market type limit factor"
				bind:value={marketTypeForm.selection_win_limit_factor}
			/>
			<div class="py-4 w-full text-left">
				<CheckBox text="Traded Pre-match" bind:checked={marketTypeForm.traded_pre_match} />
			</div>
			<div class="py-4 w-full text-left">
				<CheckBox text="Traded In-play" bind:checked={marketTypeForm.traded_in_play} />
			</div>
			<div class="py-4 w-full text-left">
				<CheckBox text="Show selections in price order" bind:checked={marketTypeForm.price_order} />
			</div>
			<div class="py-4 w-full text-left">
				<CheckBox text="Cashout enabled" bind:checked={marketTypeForm.cashout_enabled} />
			</div>
			<LoadingButton on:click={() => updateMarketType()} loading={sending} className="my-4 btn btn-primary">
				{sending ? 'Updating' : 'Update'}
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}>Cancel</button>
		</div>
	</Modal>
{/if}
